export default [
    {
        path: '/conciliation2',
        // name: 'conciliation2',
        meta: {
            isSection: true
        },
        // component: () => import('@/views/conciliation/index.vue')
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: '',
                name: 'conciliation2',
                component: () => import('@/views/conciliation2/index.vue')
            },
            {
                path: 'conciliation2-details',
                name: 'conciliation2-details',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: 'conciliation2-details', id: '', product: route.query.product, currency: route.query.currency }),
                meta: {
                    isView: true
                }
            }
        ]
    }
];
